import React, { Fragment, useState, useEffect } from "react";
import { Col, Form, Container, Row, Modal, Button } from "react-bootstrap";
import { TextField, FormControl, Select } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

import Radio from "@material-ui/core/Radio";
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
import { connect, useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  UPDATE_PAYMENT_METHOD,
  UPDATE_PAYMENT_WALLET_DETAILS,
} from "../../../../src/store/types";
import { getPendingPayment } from "../../../function/getPendingPayment";
import CashModal from "../../reusableComponents/CashModalComponent";
const OrderPaymentMain = (props) => {
  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = useState(0);
  const [showCashModal, setShowCashModal] = useState(false);
  const payment_method = useSelector(
    (state) => state.vendorOrdering.vendor_order_data
  );

  const onChangePaymentType = (id) => {
    if (id === 8) {
      setShowCancel(true);
      setSelectedValue(id);
      dispatch({ type: UPDATE_PAYMENT_METHOD, payload: id });
    } else if (id === 9) {
      setShowCashModal(true);
      setSelectedValue(id);
      dispatch({ type: UPDATE_PAYMENT_METHOD, payload: id });
    } else {
      setSelectedValue(id);
      dispatch({ type: UPDATE_PAYMENT_METHOD, payload: id });
    }
  };

  // const calcFinalTotal = (data) => {
  //   let charges = 0;
  //   for (let i = 0; i < data.length; i++) {
  //     charges = data[i][0].charges * data[i][0].quantity + charges;
  //   }

  //   let price = 0;
  //   for (let i = 0; i < data.length; i++) {
  //     price = data[i][0].finalPrice * data[i][0].quantity + price;
  //   }

  //   let finalTotal = charges + price;

  //   if (props.user_data && props.user_data.tip && props.user_data.tip.amount) {
  //     finalTotal = finalTotal + props.user_data.tip.amount;
  //   }
  //   if (
  //     props.user_data &&
  //     props.user_data.donation &&
  //     props.user_data.donation.amount
  //   ) {
  //     finalTotal = finalTotal + props.user_data.donation.amount;
  //   }
  //   return finalTotal.toFixed(2);
  // };

  const calcSubstituteSurCharges = (data) => {
    let surCharges = 0;
    //let itemTotalIncludingAddon = this.calcAllCharges(data);

    for (let i = 0; i < data.length; i++) {
      let actualPrice = 0;
      actualPrice += parseInt(data[i].size.price) * data[i].quantity;
      for (let j = 0; j < data[i].addOns.length; j++) {
        for (let k = 0; k < data[i].addOns[j].options.length; k++) {
          actualPrice +=
            parseInt(data[i].addOns[j].options[k].price) * data[i].quantity;
        }
      }
      for (let m = 0; m < data[i].sur_charges.length; m++) {
        if (data[i].sur_charges[m].flag === "VALUE") {
          surCharges = surCharges + parseFloat(data[i].sur_charges[m].value);
        } else {
          let calcPercentage =
            (actualPrice * parseFloat(data[i].sur_charges[m].value)) / 100;
          surCharges = surCharges + calcPercentage;
        }
      }
    }
    return surCharges.toFixed(2);
  };

  const calcSubsTotalIncludingAddon = (data) => {
    let itemPrice = 0;
    let addOns = 0;

    for (let i = 0; i < data.length; i++) {
      itemPrice += parseInt(data[i].size.price) * data[i].quantity;
      for (let j = 0; j < data[i].addOns.length; j++) {
        for (let k = 0; k < data[i].addOns[j].options.length; k++) {
          addOns +=
            parseInt(data[i].addOns[j].options[k].price) * data[i].quantity;
        }
      }
    }

    return parseFloat(itemPrice + addOns).toFixed(2);
  };

  const calcSubstituteTotal = (data) => {
    let total = calcSubsTotalIncludingAddon(data);
    let charges = calcSubstituteSurCharges(data);
    let finalSubTotal = parseFloat(total) + parseFloat(charges);

    return parseFloat(finalSubTotal).toFixed(2);
  };

  const calcAllCharges = (data) => {
    let itemPrice = 0;
    let addOns = 0;

    itemPrice = data.size.price * data.quantity;

    for (let i = 0; i < data.addOns.length; i++) {
      for (let j = 0; j < data.addOns[i].options.length; j++) {
        addOns =
          addOns + parseInt(data.addOns[i].options[j].price) * data.quantity;
      }
    }

    return itemPrice + addOns;
  };

  const calcCharges = (data) => {
    let itemPrice = [];
    let price = 0;
    let percent = [];
    let discount = 0;
    let discountValues = [];
    for (let i = 0; i < data.length; i++) {
      price = parseFloat(calcAllCharges(data[i])) + price;
      itemPrice.push(parseFloat(calcAllCharges(data[i])));
    }
    if (props.user_data?.discount?.amount) {
      let totalPrice = itemPrice.reduce((pV, cV) => pV + cV, 0);
      itemPrice.forEach((e) => {
        percent.push(((e / totalPrice) * 100).toFixed(2));
      });
      discount = props?.user_data?.discount?.amount;
    }
    percent.forEach((e) => {
      discountValues.push(parseFloat((discount * e) / 100).toFixed(2));
    });

    let finalCharge = 0;
    for (let i = 0; i < data.length; i++) {
      let chargePercentage = 0;
      let chargeValue = 0;
      for (let j = 0; j < data[i].sur_charges.length; j++) {
        if (data[i].sur_charges[j].flag === "PERCENTAGE") {
          chargePercentage += parseFloat(data[i].sur_charges[j].value);
        } else {
          chargeValue +=
            parseFloat(data[i].sur_charges[j].value) * data[i].quantity;
        }
      }
      if (chargePercentage)
        finalCharge +=
          ((itemPrice[i] - parseFloat(discountValues[i] || 0)) *
            chargePercentage) /
          100;
      if (chargeValue) finalCharge += chargeValue;
    }
    return finalCharge.toFixed(2);
  };

  const calcFinalTotal = (data) => {
    let itemPrice = [];
    let price = 0;
    let percent = [];
    let discount = 0;
    for (let i = 0; i < data.length; i++) {
      price = parseFloat(calcAllCharges(data[i])) + price;
      itemPrice.push(parseFloat(calcAllCharges(data[i])));
    }
    if (props.user_data?.discount?.amount) {
      let totalPrice = itemPrice.reduce((pV, cV) => pV + cV, 0);
      itemPrice.forEach((e) => {
        percent.push(((e / totalPrice) * 100).toFixed(2));
      });
      discount = props?.user_data?.discount?.amount;
    }
    let taxes = calcCharges(data);
    let finalTotal = parseFloat(price) + parseFloat(taxes);
    finalTotal = finalTotal - discount;

    if (props?.user_data?.tip?.amount) {
      finalTotal = finalTotal + props.user_data.tip.amount;
    }
    if (props?.user_data?.donation?.amount) {
      finalTotal = finalTotal + props.user_data.donation.amount;
    }
    return finalTotal?.toFixed(2) || 0;
  };

  const getTotal = () => {
    let newData = [];
    let oldData = [];

    oldData = props.user_data?.order_items;
    let itemId = props.item.map((e) => e._id);
    newData = props.user_data?.order_items.filter(
      (e) => !itemId.includes(e._id)
    );
    newData = [...newData, ...props?.cart_data[0]];

    let oldPrice = calcFinalTotal(oldData);
    let newPrice = calcFinalTotal(newData);

    return (newPrice - oldPrice).toFixed(2);
  };

  //const [ok, okk] = useState([]);
  const [paymentData, setPaymentData] = useState([
    {
      id: 6,
      title: "Pay later",
      value: "Pay later",
      icon: require("../../../assets/images/superadmin/ordericon/credit-card (1).svg"),
      show: true,
    },
    {
      id: 9,
      title: "Cash",
      value: "Cash",
      icon: require("../../../assets/images/superadmin/ordericon/credit-card (1).svg"),
      show: true,
    },
    {
      id: 8,
      title: "External Wallet",
      value: "Wallet",
      icon: require("../../../assets/images/superadmin/ordericon/credit-card (1).svg"),
      show: true,
    },
    {
      id: 1,
      title: "BHIM UPI",
      value: "BHIM UPI",
      icon: require("../../../assets/images/Orders/sdmlM4R-_400x400.png"),
      show: false,
    },
    {
      id: 2,
      title: "PayTM",
      value: "PayTM",
      icon: require("../../../assets/images/superadmin/ordericon/credit-card (1).svg"),
      show: false,
    },
    {
      id: 3,
      title: "Debit Card",
      value: "Debit Card",
      icon: require("../../../assets/images/superadmin/ordericon/credit-card (1).svg"),
      show: true,
    },
    {
      id: 4,
      title: "Credit Card",
      value: "Credit Card",
      icon: require("../../../assets/images/superadmin/ordericon/phone-credit card-money-finance.svg"),
      show: true,
    },
    {
      id: 5,
      title: "Net Banking",
      value: "Net Banking",
      icon: require("../../../assets/images/superadmin/ordericon/online-payment.svg"),
      show: false,
    },
  ]);

  useEffect(() => {
    setSelectedValue(payment_method.payment_method);
    let existingPayment = [...paymentData];
    let paymentArr = [];
    if (payment_method.payment_method === 0) {
      paymentArr.push(0);
    } else {
      paymentArr.push(3, 4);
    }
    for (let i = 0; i < existingPayment.length; i++) {
      if (paymentArr.includes(existingPayment[i].id)) {
        existingPayment[i].show = true;
      }
    }
    setPaymentData(existingPayment);
  }, [payment_method]);

  const [showCancel, setShowCancel] = useState(false);

  const submitExternal = (data) => {
    dispatch({
      type: UPDATE_PAYMENT_WALLET_DETAILS,
      payload: data,
    });
    dispatch({ type: UPDATE_PAYMENT_METHOD, payload: 8 });
    setShowCancel(false);
  };

  return (
    <React.Fragment>
      <MuiThemeProvider theme={theme}>
        <Container fluid>
          <h3>Payment</h3>
          <div style={{ paddingTop: "2%" }}>
            <Row>
              <Col md={6}>
                <TextField
                  disabled
                  id="outlined-basic"
                  label="First Name"
                  variant="outlined"
                  className="w-100"
                  value={props?.user_data?.user_details?.first_name || ""}
                />
              </Col>
              <Col md={6}>
                <TextField
                  disabled
                  id="outlined-basic"
                  label="Last Name"
                  variant="outlined"
                  className="w-100"
                  value={props?.user_data?.user_details?.last_name || ""}
                />
              </Col>
            </Row>
            <br />
            <PhoneComponent
              mobile_number={props.user_data.user_details.mobile_number}
              country_code={props.user_data.user_details.country_code}
            />
            {/* <Row style={{ paddingLeft: "30px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={true}
                    color="primary"
                    //   onChange={handleChange}
                    name="checkedA"
                  />
                }
                label="Would you like to get receipt in email?"
              />
            </Row> */}

            <hr />

            <Container fluid>
              {/* <h5>Order Details</h5>
              <br />
              Order ID: <span style={{ color: "#F85032" }}>214536878</span>
              <br />
              <br />
              Order Type: <span className="badge badge-warning">Take Away</span>
              <br />
              <br />
              <Row style={{ backgroundColor: "#ffffff", padding: "15px" }}>
                <Col md={3}>
                  <b>29th August 2019 </b>
                  <br />
                  <span style={{ color: "#757575" }}>Date</span>
                </Col>
                <Col md={2}>
                  <b>09:30 PM </b>
                  <br />
                  <span style={{ color: "#757575" }}>Time</span>
                </Col>
                <Col md={4}>
                  <b>50 Mins Preparation </b>
                  <br />
                  <span style={{ color: "#757575" }}>Time</span>
                </Col>
                <Col md={3}>
                  <b>2 Items </b>
                  <br />
                  <span style={{ color: "#757575" }}>Quantity</span>
                </Col>
              </Row> */}
              <br />
              {props.cart_data.length > 0 ? (
                <Row
                  style={{
                    backgroundColor: "#FFFBEE",
                    padding: "15px",
                    display: "flex",
                  }}
                  className="align-middle"
                >
                  <p style={{ fontWeight: "bold", fontSize: "1.5rem" }}>
                    ₹{" "}
                    {(props.history?.location?.state?.allData.revised).toFixed(2)}
                  </p>
                  <p style={{ color: "#212121" }}>Total Amount To Be Paid</p>
                </Row>
              ) : (
                <Fragment></Fragment>
              )}
              <hr />
              <h5>Select payment method</h5>
              <br />
              {paymentData.map((data, index) => {
                return (
                  <Fragment key={index}>
                    {data.show ? (
                      <PaymentsInfo
                        data={data}
                        selectedValue={selectedValue}
                        handlePaymentType={() => onChangePaymentType(data.id)}
                      />
                    ) : (
                      <Fragment></Fragment>
                    )}
                  </Fragment>
                );
              })}
              {showCancel && (
                <ExternalReference
                  hideCancel={() => setShowCancel(false)}
                  submitExternal={submitExternal}
                />
              )}
              {showCashModal && (
                <CashModal
                  hideModal={() => setShowCashModal(false)}
                  total={(
                    parseFloat(getTotal()) +
                    parseFloat(getPendingPayment(props.user_data) || 0)
                  ).toFixed(2)}
                  cartData={props?.cart_data}
                  userData={props?.user_data}
                  offerData={props?.offerData}
                  subscriptionData={props?.subscription}
                />
              )}
            </Container>
          </div>
        </Container>
      </MuiThemeProvider>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  cart_data: state.vendorOrdering.vendor_cart_data,
  user_data: state.vendorOrdering.vendor_order_data,
  item: state.vendorOrdering.substitute_item_data,
  subscription: state.onboarding.onboard_subscription_details,
});

export default withRouter(connect(mapStateToProps, null)(OrderPaymentMain));

const theme = createTheme({
  palette: {
    primary: { main: "#EE3A23" }, // Purple and green play nicely together.
    secondary: { main: "#9E9E9E" }, // This is just green.A700 as hex.
  },
});

const PaymentsInfo = (props) => {
  const [data, setData] = React.useState(props.data);
  const [view, setView] = React.useState(false);
  return (
    <div>
      <Row style={{ backgroundColor: "#ffffff", padding: "15px" }}>
        <Col md={1}>
          <Radio
            checked={data.id === props.selectedValue ? true : false}
            onChange={(e) => {
              setView(true);
              props.handlePaymentType(e.target.value);
            }}
            value={data.value}
            name="radio-button-demo"
            color="primary"
            inputProps={{ "aria-label": data.value }}
          />
        </Col>
        <Col md={1}>
          <img src={data.icon} />
        </Col>
        <Col md={8}>
          <b>{data.title}</b>
        </Col>
        <Col md={2}>arrow</Col>
      </Row>
      {data.value === "PayTM" && props.selectedValue === "PayTM" && (
        <Container style={{ padding: "20px" }}>
          <h5>Send a Request to</h5>
          <br />
          <b>Enter Mobile Number</b>
          <br />
          <PhoneComponent />
          <div class="mt-3 d-flex">
            <button
              type="button"
              class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
              title="Cancel Button"
            >
              Cancel
            </button>
            <button
              type="button"
              class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
              title="Save Button"
            >
              Send Link
            </button>
          </div>
        </Container>
      )}
    </div>
  );
};

export const PhoneComponent = (props) => {
  return (
    <Row>
      <Col xs={12} md={8}>
        <Row>
          <Col xs={4} className="pr-0">
            <Form.Group controlId={"country_code"}>
              <FormControl variant="outlined" className="w-100">
                <Select
                  disabled
                  value={+91}
                  // onChange={handleChangeCode}
                  inputProps={{
                    name: "code",
                  }}
                  IconComponent={KeyboardArrowDownIcon}
                >
                  <option value={+91}>{props.country_code}</option>
                </Select>
              </FormControl>
            </Form.Group>
          </Col>
          <Col xs={8}>
            <Form.Group>
              <TextField
                disabled
                id="outlined-basic"
                label="Phone Number"
                variant="outlined"
                className="w-100"
                value={props.mobile_number}
              />
            </Form.Group>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const ExternalReference = (props) => {
  const [ref, setRef] = useState("");
  const [refErr, setRefErr] = useState(false);

  const handleDesc = (e) => {
    if (!e.target.value) {
      setRefErr(true);
    } else {
      setRefErr(false);
      setRef(e.target.value);
    }
  };

  const submitCancel = () => {
    if (ref) {
      props.submitExternal(ref);
    } else {
      setRefErr(true);
    }
  };

  return (
    <React.Fragment>
      <Modal show={true} onHide={props.hideCancel} centered>
        <Modal.Header className="border-0" closeButton>
          <div className="f18-700">Enter Transaction Reference</div>
        </Modal.Header>
        <Modal.Body>
          <div className="f18-500 mt-2 mb-4">
            <Form.Group>
              <TextField
                id="reference"
                variant="outlined"
                label="Reference"
                name="reference"
                className={`w-100  ${refErr ? "enError" : ""}`}
                helperText={refErr ? "Enter Transaction Reference" : ""}
                onChange={handleDesc}
                value={ref}
              />
            </Form.Group>
          </div>
          <div className="mt-4">
            <div className="row">
              <div className="col-6">
                <Button
                  variant="outline-secondary"
                  className="btn-md py-2 mb-2"
                  style={{ width: "90%" }}
                  onClick={props.hideCancel}
                >
                  Cancel
                </Button>
              </div>
              <div className="col-6">
                <Button
                  variant="danger"
                  className="btn-md py-2 mb-2 w-100"
                  onClick={submitCancel}
                >
                  Done
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
